import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';

export interface ImpairmentEntry {
  valor: string;
  inicioVigencia: string | null;
}

export interface Aranceles {
  name: string;
  modules: Module[];
  additionals: Additional[];
  coverage: Coverage[];
  impairment?: ImpairmentEntry[];
  coinsurance?: string;
  observations?: string;
  activo?: boolean;
}

export interface Pacto {
  id: number;
  fechaInicioVigencia: string;
  fechaFinVigencia: string | null;
  activo: boolean;
}

export interface Module {
  descripcion: string;
  basico: string;
  catA: string;
  catB: string;
  catC: string;
}

export interface Additional {
  descripcion: string;
  nombre?: string;
  monto: string;
}

export interface Coverage {
  nivelUbicacion: string;
  nombre: string;
}


export async function getAranceles(insurerId: number, pactoId?: number): Promise<Aranceles> {
  const url = new URL(`${ config.baseUrl }/insurers/${ insurerId }/duty`);
  if (pactoId !== undefined) {
    url.searchParams.set('pacto_id', String(pactoId));
  }

  type Response = APIResponse<Aranceles> & { message?: string };

  let response: globalThis.Response;
  try {
    response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });
  } catch (err) {
    console.error(err);
    throw new Error('Ocurrió un problema inesperado al momento de recuperar los aranceles.');
  }

  if (response.status !== 200) {
    console.error(response.statusText);
    throw new Error('Ocurrió un error al recuperar los aranceles.');
  }

  const content = await response.json() as Response;

  if (content.status !== 'ok' || !content.payload) {
    console.error(content.error ?? content.message);
    throw new Error(content.message ?? 'Ocurrió un error al recuperar los aranceles.');
  }

  return content.payload;
}

export async function getPactos(insurerId: number): Promise<Pacto[]> {
  const url = new URL(`${ config.baseUrl }/insurers/${ insurerId }/duty/pactos`);

  type Response = APIResponse<Pacto[]> & { message?: string };

  let response: globalThis.Response;
  try {
    response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });
  } catch (err) {
    console.error(err);
    throw new Error('Ocurrió un problema inesperado al momento de recuperar los pactos.');
  }

  if (response.status !== 200) {
    console.error(response.statusText);
    throw new Error('Ocurrió un error al recuperar los pactos.');
  }

  const content = await response.json() as Response;

  if (content.status !== 'ok' || !content.payload) {
    console.error(content.error ?? content.message);
    throw new Error(content.message ?? 'Ocurrió un error al recuperar los pactos.');
  }

  return content.payload;
}
